export default {
  baseStyle: {
    label: {
      color: 'muted',
    },
  },
}
